import React, { useEffect, useState } from 'react';
import { Modal, Spin, Typography, Space } from 'antd';
import { ShopOutlined, CloseOutlined } from '@ant-design/icons';
import { getFarmaciaTitulares, AuraFarmaciaResponse } from '../api/auraApi';

const { Text, Title } = Typography;

interface FarmaciaTitularesModalProps {
  visible: boolean;
  onClose: () => void;
  farmaciaId: number;
  farmaciaName: string;
  userId: number;
  modo?: 'titulares' | 'empleados';
}

const FarmaciaTitularesModal: React.FC<FarmaciaTitularesModalProps> = ({
  visible,
  onClose,
  farmaciaId,
  farmaciaName,
  userId,
  modo = 'titulares',
}) => {
  const opcion = modo === 'empleados' ? 6 : 2;
  const label = modo === 'empleados' ? 'Empleados en Gescom' : 'Titulares en Gescom';
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AuraFarmaciaResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (visible && farmaciaId && userId) {
      loadTitulares();
    }
    if (!visible) {
      setData(null);
      setError(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, farmaciaId, userId, opcion]);

  const loadTitulares = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFarmaciaTitulares(farmaciaId, userId, opcion);
      setData(response);
    } catch (err) {
      console.error('Error loading titulares:', err);
      setError('Error al cargar los titulares');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={450}
      centered
      bodyStyle={{
        padding: 0,
        backgroundColor: '#f6ffed',
        borderRadius: 8,
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '16px 20px',
          borderBottom: '1px solid #b7eb8f',
          backgroundColor: '#f6ffed',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <ShopOutlined style={{ fontSize: 18, color: '#52c41a' }} />
            <Title level={5} style={{ margin: 0, color: '#237804' }}>
              Farmacia
            </Title>
          </div>
          <Text style={{ color: '#595959', fontSize: 14 }}>
            {farmaciaName || 'Sin datos'}
          </Text>
        </div>
        <CloseOutlined
          onClick={onClose}
          style={{
            fontSize: 16,
            color: '#8c8c8c',
            cursor: 'pointer',
            padding: 4,
          }}
        />
      </div>

      {/* Body */}
      <div style={{ padding: '20px', minHeight: 120 }}>
        <Text strong style={{ display: 'block', marginBottom: 16, color: '#237804' }}>
          {label}
        </Text>

        {loading && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Spin />
          </div>
        )}

        {error && (
          <Text type="danger">{error}</Text>
        )}

        {!loading && !error && data && (() => {
          const personas = (modo === 'empleados' ? data.empleados : data.titulares) || [];
          return (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            {personas.length > 0 ? (
              personas.map((titular) => (
                <div
                  key={titular.id}
                  style={{
                    padding: '8px 12px',
                    backgroundColor: '#ffffff',
                    borderRadius: 4,
                    border: '1px solid #d9f7be',
                  }}
                >
                  <Text>{titular.nombreCompleto}</Text>
                </div>
              ))
            ) : (
              <Text type="secondary">{modo === 'empleados' ? 'No hay empleados registrados' : 'No hay titulares registrados'}</Text>
            )}
          </Space>
          );
        })()}
      </div>
    </Modal>
  );
};

export default FarmaciaTitularesModal;
